<script lang="ts">
import type { HTMLAttributes } from 'vue'
import type { AvatarProps } from '#ui-kit/ui/avatar'

export interface PlaceholderAvatarProps {
  src?: string | null
  alt?: string
  size?: AvatarProps['size']
  bordered?: boolean
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { Avatar, AvatarFallback, AvatarImage } from '#ui-kit/ui/avatar'

const props = withDefaults(defineProps<PlaceholderAvatarProps & { placeholder: string }>(), {
  size: 'sm',
})
</script>

<template>
  <Avatar
    :size="props.size"
    :bordered="props.bordered"
    :class="props.class"
    :aria-hidden="props.alt ? undefined : 'true'"
  >
    <AvatarImage v-if="props.src" :src="props.src" :alt="props.alt ?? ''" />
    <AvatarFallback class="bg-white">
      <img :src="props.placeholder" :alt="props.alt ?? ''" class="size-full object-cover" />
    </AvatarFallback>
  </Avatar>
</template>
